/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="wd720">
                <Message v-if="apivalidationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
                <Message v-if="apivalidationMessage" :validationMessage="apivalidationMessage" />
            </div>
            <form class="form_companyBrand" v-on:submit.prevent="onsubmit">

                <div class="lavel_companyBrand right_comment">
                    <img class="required" src="../assets/required.png" />
                    <label for="target">対象</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <select id="target" v-model="targetSelectValue" class="wd400" @change="changeTarget()">
                        <option value=null disabled>対象を選択</option>
                        <option v-for="targetList in targetLists" :key="targetList" :value="targetList.targetValue">
                            {{targetList.targetName}}</option>
                    </select><br>
                    <label id="targeterror" class="lavel_error_font wd400">{{validation.targetResult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <img v-if="targetSelectValue!==null && selectKbn !== 7 && selectKbn !== 8 && selectKbn !== 9 && selectKbn !== 12"
                         class="required" src="../assets/required.png" />
                    <label for="company">企業</label>
                </div>
                <div class="input_companyBrand left_comment ">
                    <div v-if="targetSelectValue==null || selectKbn == 12">
                        <select class="wd400" disabled>
                            <option value="" hidden>企業を選択</option>
                        </select><br>
                    </div>
                    <div v-else>
                        <select id="company" v-model="companySelectValue" class="wd400" @change="changeCompany" >
                            <option value=null disabled>企業を選択</option>
                            <option v-for="companyList in companyLists" :key="companyList" :value="companyList.id">
                                {{companyList.companyName}} {{companyList.brandName}}</option>
                        </select><br>
                    </div>
                    <label id="companyerror" class="lavel_error_font wd400">{{validation.companyResult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <img v-if="targetSelectValue!==null  && selectKbn !== 7 && selectKbn !== 8 && selectKbn !== 9 && selectKbn !== 10 && selectKbn !== 11 && selectKbn !== 12"
                         class="required" src="../assets/required.png" />
                    <label for="stor">店舗</label>
                </div>
                <div class="input_companyBrand left_comment">
                    <div v-if="storeLists==null">
                        <select class="wd400" disabled>
                            <option value="" hidden>店舗を選択</option>
                        </select><br>
                    </div>
                    <div v-else>
                        <select id="stor" v-model="storeSelectValue" class="wd400" >
                            <option value=null disabled>店舗を選択</option>
                            <option v-for="storeList in storeLists" :key="storeList" :value="storeList.storeId">
                                {{storeList.storeName}}</option>
                        </select><br>
                    </div>
                    <label id="storerror" class="lavel_error_font wd400">{{validation.storeResult}}</label>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <label for="sensorId1" class="mgt_8">センサーID①</label>
                </div>
                <div class="input_companyBrand left_comment" id="sensorId1">
                    <div class="wd250">
                        <div v-if="selectKbn == 12">
                            <input type="text" v-model="sensorId1Value" class="wd250" maxlength="11">
                        </div>
                        <div v-else>
                            <input type="text" v-model="sensorId1Value" class="wd250" disabled>
                        </div>
                    </div>
                     <label id="storerror" class="lavel_error_font wd400">{{validation.sensorIdResult}}</label>
                </div>
                <div class="lavel_companyBrand right_comment">
                    <label for="sensorId2" class="mgt_8">センサーID②</label>
                </div>
                <div class="input_companyBrand left_comment" id="sensorId2">
                    <div class="wd250">
                        <div v-if="selectKbn == 12">
                            <input type="text" v-model="sensorId2Value" class="wd250" maxlength="11">
                        </div>
                        <div v-else>
                            <input type="text" v-model="sensorId2Value" class="wd250" disabled>
                        </div>
                    </div>
                </div>
                <div class="lavel_companyBrand right_comment">
                    <label for="sensorId3" class="mgt_8">センサーID③</label>
                </div>
                <div class="input_companyBrand left_comment" id="sensorId3">
                    <div class="wd250">
                        <div v-if="selectKbn == 12">
                            <input type="text" v-model="sensorId3Value" class="wd250" maxlength="11">
                        </div>
                        <div v-else>
                            <input type="text" v-model="sensorId3Value" class="wd250" disabled>
                        </div>
                    </div>
                </div>
                <div class="lavel_companyBrand right_comment">
                    <label for="sensorId4" class="mgt_8">センサーID④</label>
                </div>
                <div class="input_companyBrand left_comment" id="sensorId4">
                    <div class="wd250">
                        <div v-if="selectKbn == 12">
                            <input type="text" v-model="sensorId4Value" class="wd250" maxlength="11">
                        </div>
                        <div v-else>
                            <input type="text" v-model="sensorId4Value" class="wd250" disabled>
                        </div>
                    </div>
                </div>
                <div class="lavel_companyBrand right_comment">
                    <label for="sensorId5" class="mgt_8">センサーID⑤</label>
                </div>
                <div class="input_companyBrand left_comment" id="sensorId5">
                    <div class="wd250">
                        <div v-if="selectKbn == 12">
                            <input type="text" v-model="sensorId5Value" class="wd250" maxlength="11">
                        </div>
                        <div v-else>
                            <input type="text" v-model="sensorId5Value" class="wd250" disabled>
                        </div>
                    </div>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <img v-if="targetSelectValue!==null  && selectKbn !== 7 && selectKbn !== 8 && selectKbn !== 9 && selectKbn !== 11"
                         class="required_adjust" src="../assets/required.png" />
                    <label for="startDay" class="mgt_8">開始日</label>
                </div>
                <div class="input_companyBrand left_comment" id="startDay">
                    <div class="wd250">
                        <input v-if="targetSelectValue==null || selectKbn == 7 || selectKbn == 8 || selectKbn == 9"
                               type="text" class="wd250 height_text_csv" disabled>
                        <v-date-picker v-else ref="picker"
                                       v-model="startdayDate"
                                       mode="single"
                                       :masks="{ input: ['YYYY/MM/DD']}"
                                       :max-date="vDatePickerMaxDay">
                        </v-date-picker><br>
                        <label id="startdayerror" class="lavel_error_font wd400">{{validation.startdayResult}}</label>
                    </div>
                </div>

                <div class="lavel_companyBrand right_comment">
                    <img v-if="targetSelectValue!==null  && selectKbn !== 7 && selectKbn !== 8 && selectKbn !== 9 && selectKbn !== 11"
                         class="required_adjust" src="../assets/required.png" />
                    <label for="endday" class="mgt_8">終了日</label>
                </div>
                <div class="input_companyBrand left_comment" id="endday">
                    <div class="wd250">
                        <input v-if="targetSelectValue==null  || selectKbn == 7 || selectKbn == 8 || selectKbn == 9"
                               type="text" class="wd250 height_text_csv" disabled>
                        <v-date-picker  v-else ref="picker"
                                        v-model="enddayDate"
                                        mode="single"
                                        :masks="{ input: ['YYYY/MM/DD']}"
                                        :max-date="vDatePickerMaxDay">
                        </v-date-picker><br>
                        <label id="enddayerror" class="lavel_error_font wd400">{{validation.enddayResult}}</label>
                    </div>
                </div>
            </form>
            <div>
                <div class="btn_submit" style="text-align: center">
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="csvExport_button_unit " href="#" @click.prevent.stop="csvExport()">出力</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">CSV出力</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>CSV出力が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
export default {
    name: 'CsvExport',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            addFormFlg:true,
            csvResponseData:null,
            showContent:false,
            isInitLoading:true,
            isLoading:false,
            apivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            validation:{
                targetResult:"",
                companyResult:"",
                storeResult:"",
                sensorIdResult:"",
                startdayResult:"",
                enddayResult:""
            },
            sensorId1Value:null,
            sensorId2Value:null,
            sensorId3Value:null,
            sensorId4Value:null,
            sensorId5Value:null,
            startdayDate:null,
            enddayDate:null,
            targetLists:[
                {targetValue:"1",targetName:"報告書 ボタンA(左) ボタンA-①",kbn:1,button:1},
                {targetValue:"2",targetName:"報告書 ボタンA(左) ボタンA-②",kbn:1,button:2},
                {targetValue:"3",targetName:"報告書 ボタンA(左) ボタンA-③",kbn:1,button:3},
                {targetValue:"4",targetName:"報告書 ボタンA(左) ボタンA-④",kbn:1,button:4},
                {targetValue:"5",targetName:"報告書 ボタンA(左) ボタンA-⑤",kbn:1,button:5},
                {targetValue:"6",targetName:"報告書 ボタンA(左) ボタンA-⑥",kbn:1,button:6},
                {targetValue:"7",targetName:"報告書 ボタンA(左) ボタンA-⑦",kbn:1,button:99},
                {targetValue:"8",targetName:"報告書 ボタンB(右) ボタンB-①",kbn:2,button:1},
                {targetValue:"9",targetName:"報告書 ボタンB(右) ボタンB-②",kbn:2,button:2},
                {targetValue:"10",targetName:"報告書 ボタンB(右) ボタンB-③",kbn:2,button:3},
                {targetValue:"11",targetName:"報告書 ボタンB(右) ボタンB-④",kbn:2,button:4},
                {targetValue:"12",targetName:"報告書 ボタンB(右) ボタンB-⑤",kbn:2,button:5},
                {targetValue:"26",targetName:"ヘッダー変更履歴 ボタンB(右) ボタンB-①",kbn:10,button:1},
                {targetValue:"27",targetName:"ヘッダー変更履歴 ボタンB(右) ボタンB-②",kbn:10,button:2},
                {targetValue:"28",targetName:"ヘッダー変更履歴 ボタンB(右) ボタンB-③",kbn:10,button:3},
                {targetValue:"29",targetName:"ヘッダー変更履歴 ボタンB(右) ボタンB-④",kbn:10,button:4},
                {targetValue:"30",targetName:"ヘッダー変更履歴 ボタンB(右) ボタンB-⑤",kbn:10,button:5},
                {targetValue:"13",targetName:"報告書 ボタンC(中上)",kbn:3},
                {targetValue:"14",targetName:"報告書 ボタンD(中下) ボタンD-①",kbn:4,button:1},
                {targetValue:"15",targetName:"報告書 ボタンD(中下) ボタンD-②",kbn:4,button:2},
                {targetValue:"16",targetName:"報告書 ボタンD(中下) ボタンD-③",kbn:4,button:3},
                {targetValue:"17",targetName:"報告書 ボタンD(中下) ボタンD-④",kbn:4,button:4},
                {targetValue:"18",targetName:"報告書 ボタンD(中下) ボタンD-⑤",kbn:4,button:5},
                {targetValue:"19",targetName:"報告書 ボタンD(中下) ボタンD-⑥",kbn:4,button:6},
                {targetValue:"20",targetName:"報告書 ボタンD(中下) ボタンD-⑦",kbn:4,button:99},
                {targetValue:"21",targetName:"温度センサーログ",kbn:5},
                {targetValue:"22",targetName:"湿度センサーログ",kbn:6},
                {targetValue:"23",targetName:"店舗",kbn:7},
                {targetValue:"24",targetName:"センサー設定",kbn:8},
                {targetValue:"25",targetName:"センサー閾値",kbn:9},
                {targetValue:"31",targetName:"異常詳細",kbn:11},
                {targetValue:"32",targetName:"sem分析",kbn:12}
            ],
            targetSelectValue:null,
            companyLists:null,
            companySelectValue:null,
            storeLists:null,
            storeSelectValue:null,
            commpanyList:null,
            targetKbn:null,
            vDatePickerMaxDay:null,
            selectKbn:null,
            buttonId:null
        }
    },
    created: function(){
        this.calc();
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        }
    },
    methods: {
        async calc() {
            // 画面描画処理
            this.isInitLoading = true;

            // 初期設定
            this.vDatePickerMaxDay = this.checkDateBusinessDay();

            // 企業の取得
            // 企業ブランド一覧取得API
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand')
                .then(response => (this.companyLists = response['data']['brand']))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);

            this.isInitLoading = false;
        },
        async changeCompany(){

            // 店舗情報が不要な対象は処理をスキップする
            if(this.selectKbn == 7 || this.selectKbn == 9 || this.selectKbn == 10){
                return ;
            }

            this.isLoading = true;
            // 店舗の選択を初期化
            this.storeLists = null;
            this.storeSelectValue = null;

            //ブランドIDを取得
            this.brandId =this.companySelectValue;

            // 管理画面店舗一覧取得API
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store')
                .then(response => (this.storeLists = response['data']['storeList']))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    this.addFormFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.apivalidationMessage =  error.message;
                            this.scrollTop();
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

        },
        async csvExport(){

            // CSV出力処理
            this.isLoading = true;

            // エラーメッセージ初期化
            this.clearError();

            // バリデーションチェック
            if(!this.validationCheck()){
                this.isLoading = false;
                this.scrollTop();
                return ;
            }

            // URL成形
            var URL = this.makeURL(this.selectKbn,this.buttonId,this.companySelectValue,this.storeSelectValue);

            // リクエスト、URL成形
            var params = new Object();
            if(this.selectKbn !== 7 && this.selectKbn !== 8 && this.selectKbn !== 9){
                
                if(this.startdayDate !== null && this.enddayDate !== null){
                    var startDate = this.selectDateFormat(this.startdayDate);
                    var endDate = this.selectDateFormat(this.enddayDate);
                    params = {
                        start_date: startDate,end_date:endDate
                    };
                }

                if(this.selectKbn == 5){
                    params.type = 1
                }
                if(this.selectKbn == 6){
                    params.type = 2
                }
                if(this.selectKbn === 11 && this.storeSelectValue !== null){
                    params.store_id = this.storeSelectValue;
                }
            }

            if(this.selectKbn == 8){
                params.brand_id = this.companySelectValue;
                params.store_id = this.storeSelectValue;
            }
            if(this.selectKbn == 7 || this.selectKbn == 9){
                params.brand_id = this.companySelectValue;
            }
            if(this.selectKbn == 12){
                params.sensor_id = [this.sensorId1Value, this.sensorId2Value, this.sensorId3Value, this.sensorId4Value, this.sensorId5Value].filter(x => x !== null);
            }

            // 呼び出しAPIの判定
            // API呼び出し
            await this.$axios
                .get(this.$apiEndpoint + URL ,{params})
                .then(response => (this.csvResponseData = response))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    this.addFormFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.apivalidationMessage =  error.message;
                            this.scrollTop();
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            if(this.addFormFlg){
                // CSV出力
                if(!this.commonDownloadCSV(this.csvResponseData)){
                    this.apivalidationMessage =  "CSVの出力に失敗しました。";
                    this.addFormFlg = false;
                    this.scrollTop();
                }
                else{
                    this.showContent = true;
                }
            }
            
        },
        closeModel(){
            this.showContent = false;
        },
        scrollTop() {
            window.scrollTo(0, 0);
        },
        validationCheck() {

            // バリデーションチェック初期化
            var validationFlg = true;

            // 必須チェック
            if(this.targetSelectValue == null || this.targetSelectValue == ""){
                this.validation.targetResult = '対象を選択してください。'
                validationFlg = false;
                // 対象が未設定の場合、バリデーションを終了する。
                return validationFlg
            }

            // 条件必須
            if(this.selectKbn !== 7 && this.selectKbn !== 8 && this.selectKbn !== 9){

                if((this.companySelectValue == null  || this.companySelectValue == "") && this.selectKbn !== 12){
                    this.validation.companyResult = '企業を入力してください。'
                    validationFlg = false;
                }
                if((this.storeSelectValue == null  || this.storeSelectValue == "") && this.selectKbn !== 10 && this.selectKbn !== 11 && this.selectKbn !== 12){
                    this.validation.storeResult = '店舗を入力してください。'
                    validationFlg = false;
                }
                // sem分析はセンサーIDを1つ以上入力必須
                if(this.selectKbn === 12){
                    if ((this.sensorId1Value == null || this.sensorId1Value == "") && (this.sensorId2Value == null || this.sensorId2Value == "") 
                    && (this.sensorId3Value == null || this.sensorId3Value == "") && (this.sensorId4Value == null || this.sensorId4Value == "") 
                    && (this.sensorId5Value == null || this.sensorId5Value == "")){
                        this.validation.sensorIdResult = 'センサーIDを1つ以上入力してください。'
                        validationFlg = false;
                    }
                }
                // 異常詳細は入力があった場合のみ必須
                if(this.selectKbn === 11){
                    if((this.startdayDate !== null  && this.startdayDate !== "") || (this.enddayDate !== null && this.enddayDate !== "")){
                        if(this.startdayDate == null  || this.startdayDate == ""){
                            this.validation.startdayResult = '開始日を入力してください。'
                            validationFlg = false;
                        }
                        if(this.enddayDate == null  || this.enddayDate == ""){
                            this.validation.enddayResult = '終了日を入力してください。'
                            validationFlg = false;
                        }
                    }
                }
                else{
                    if(this.startdayDate == null  || this.startdayDate == ""){
                        this.validation.startdayResult = '開始日を入力してください。'
                        validationFlg = false;
                    }
                    if(this.enddayDate == null  || this.enddayDate == ""){
                        this.validation.enddayResult = '終了日を入力してください。'
                        validationFlg = false;
                    }
                }
            }

            if(validationFlg){
                if(this.selectKbn !== 7 && this.selectKbn !== 8 && this.selectKbn !== 9){

                    // 異常詳細は入力がない場合のみチェックスキップする
                    if(this.selectKbn === 11 && this.startdayDate === null && this.enddayDate === null){
                        // 日付選択がない場合、処理スキップ
                        return validationFlg;
                    }

                    // 日付比較(現在日付または過去日の指定チェック 開始日)
                    if(this.selectDateFormat(this.startdayDate) > this.selectDateFormat(this.checkDateBusinessDay())){
                        this.validation.startdayResult = '開始日は、現在日付または過去日を入力してください。'
                        validationFlg = false;
                    }
                    // 日付比較(現在日付または過去日の指定チェック 終了日)
                    if(this.selectDateFormat(this.enddayDate) > this.selectDateFormat(this.checkDateBusinessDay())){
                        this.validation.enddayResult = '終了日は、現在日付または過去日を入力してください。'
                        validationFlg = false;
                    }
                    // 日付比較(終了日は開始日と同じまたは未来である事)
                    if(this.selectDateFormat(this.startdayDate) > this.selectDateFormat(this.enddayDate)){
                        this.validation.enddayResult = '終了日は、開始日と同じまたは未来日を入力してください。'
                        validationFlg = false;
                    }
                    // 開始日・終了日の指摘期間は最大90日
                    if(((this.enddayDate - this.startdayDate)/86400000 + 1) > 90){
                        this.validation.enddayResult = '開始日・終了日の期間指定は、90日以内で入力してください。'
                        validationFlg = false;
                    }
                }
            }

            return validationFlg;
        },
        checkDateBusinessDay(){
            // 現在の営業日を取得
            let minAllowedDay = new Date();
            let hours = ("0" + minAllowedDay.getHours()).slice(-2);

            // AM00-AM03時の判定
            if(hours >= '00' && hours <= '02'){
                minAllowedDay.setDate(minAllowedDay.getDate() -1);
            }
            return new Date(minAllowedDay.getFullYear(),minAllowedDay.getMonth(),minAllowedDay.getDate());
        },
        selectDateFormat(date){
            let year = date.getFullYear();
            let month = ("0" + (date.getMonth()+1)).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);

            let format_str = 'YYYY/MM/DD';
            format_str = format_str.replace(/YYYY/g,year);
            format_str = format_str.replace(/MM/g,month);
            format_str = format_str.replace(/DD/g,day);

            return format_str;
        },
        clearError(){
            //メッセージ初期化
            this.validation.targetResult = "";
            this.validation.companyResult = "";
            this.validation.storeResult = "";
            this.validation.sensorIdResult = "";
            this.validation.startdayResult = "";
            this.validation.enddayResult = "";
            this.apivalidationMessage = "";
        },
        changeTarget(){

            // 設定
            for(var i = 0 ; i < this.targetLists.length ; i++){
                if(this.targetSelectValue == this.targetLists[i].targetValue){
                    this.selectKbn = this.targetLists[i].kbn;
                    this.buttonId =  this.targetLists[i].button;
                    break
                }
            }

            this.clearError();
            // 対象変更した時、選択対象を初期化
            this.companySelectValue = null;
            this.storeLists = null;
            this.storeSelectValue = null;
            this.sensorId1Value = null;
            this.sensorId2Value = null;
            this.sensorId3Value = null;
            this.sensorId4Value = null;
            this.sensorId5Value = null;
            this.startdayDate = null;
            this.enddayDate = null;
        },
        makeURL(Kbn,buttonId,brandId,storeId){
            // kbnを判定してURLを生成する
            var url = "";
            switch (Kbn) {
                case 1:
                    // 報告書 店舗チェック1
                    url = 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/daily/' + Kbn + '/' + buttonId;
                    break;
                case 2:
                    // 報告書 重要管理項目
                    url = 'manage/brand/' + brandId + '/store/' + storeId + '/report/csv/cooking/' + buttonId;
                    break;
                case 3:
                    // 報告書 健康身だしなみ
                    url = 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/health';
                    break;
                case 4:
                    // 報告書 店舗チェック2
                    url = 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/daily/' + Kbn + '/' + buttonId;
                    break;
                case 5:
                    // 温度ログ
                    url =  'manage/brand/'+ brandId +'/store/'+ storeId + '/temperature_humidity/csv';
                    break;
                case 6:
                    // 湿度ログ
                    url =  'manage/brand/'+ brandId +'/store/'+ storeId + '/temperature_humidity/csv';
                    break;
                case 7:
                    // 店舗
                    url = 'manage/store/csv';
                    break;
                case 8:
                    // センサー設定
                    url = 'manage/measuring_instruments/setting/history/csv';
                    break;
                case 9:
                    // センサー閾値
                    url = 'manage/measuring_instruments_threshold/setting/csv';
                    break;
                case 10:
                    // 重要管理項目ヘッダー変更履歴
                    url = 'manage/brand/' + brandId + '/report/csv/cooking/header/history/' + buttonId;
                    break;
                case 11:
                    // 異常詳細
                    url = 'manage/brand/' + brandId + '/sensor_accident/csv/history';
                    break;
                case 12:
                    // sem分析
                    url = 'manage/brand/' + brandId + '/sensor_accident/csv/sem';
                    break;
            }
            return url;
        }
    }
}
</script>
